import { Button, Modal, Skeleton, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import AddKirimKaliy from "./AddKirimKaliy";
import {
  IoIosAddCircleOutline,
  IoMdInformationCircleOutline,
} from "react-icons/io";
import TicketList from "../../../../Components/Tickets/TicketList";
import axiosInstance from "../../../../Components/axiosInstance/AxiosInstance";
import { useMessage } from "../../../../Components/MessageProvider/MessageProvider";
import moment from "moment";
import { Link } from "react-router-dom";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";
import EditKaliyKirim from "./EditKaliyKirim";

export default function KaliyKirim() {
  const messageApi = useMessage();
  let [loading, setLoading] = useState(false);
  let [data, setData] = useState([]);
  let [modalData, setModalData] = useState([]);
  let [isModalOpen, setIsModalOpen] = useState(false);
  let [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  let [isEditModalOpen, setIsEditModalOpen] = useState(false);

  let getKirim = async () => {
    try {
      setLoading(true);
      let { data: info } = await axiosInstance.get(
        "/api/kirim-official?zavod=Kaliy"
      );

      console.log(info);

      if (info.success) {
        setData([...info.data]);
      }
    } catch (error) {
      // getNames();
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getKirim();
  }, []);

  const copyContent = async (text) => {
    try {
      await navigator.clipboard.writeText(text);

      messageApi.open({
        type: "success",
        content: "Copied!",
      });
    } catch (err) {
      messageApi.open({
        type: "success",
        content: "Failed to copy!",
      });
    }
  };

  // loading
  if (loading) {
    return (
      <div className="pb-[50px]">
        <div className="w-[100%] flex flex-col items-start md:gap-2 overflow-auto">
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
        </div>
      </div>
    );
  }

  if (data?.length == 0 || !data) {
    return (
      <div>
        <main class="grid  place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div class="text-center">
            <AddKirimKaliy
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
            />
            <Button
              onClick={() => {
                setIsModalOpen(true);
              }}
              icon={<IoIosAddCircleOutline />}
              size="large"
              className=" rounded-xl fixed bottom-[5%] right-[2%]"
            ></Button>
            <p class="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              Kirim mavjud emas
            </p>
            <div class="mt-10 flex items-center justify-center gap-x-6">
              <Link
                to="/tickets"
                class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Tiketlar
              </Link>
              <Link
                to="/tickets/kirim"
                class="text-sm font-semibold text-gray-900"
              >
                Kirimlar <span aria-hidden="true">&rarr;</span>
              </Link>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div>
      <AddKirimKaliy
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <EditKaliyKirim
        isModalOpen={isEditModalOpen}
        setIsModalOpen={setIsEditModalOpen}
        info={modalData}
      />
      <Button
        onClick={() => {
          setIsModalOpen(true);
        }}
        icon={<IoIosAddCircleOutline />}
        size="large"
        className=" rounded-xl fixed bottom-[5%] right-[2%]"
      ></Button>
      {/*  lists */}
      <div className="max-w-[900px] w-[100%] overflow-auto m-auto flex flex-col items-start gap-2 ">
        {data?.map((el, i) => {
          console.log(el);
          return (
            <div
              onContextMenu={(e) => {
                e.preventDefault();
                console.log(e);
              }}
              className="shrink-0 min-w-[600px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 "
            >
              <Modal
                title={`Kirimni ${data[i]?.written_by} yozgan!`}
                open={isInfoModalOpen}
                loading={loading}
                style={{ top: 20 }}
                onOk={() => {
                  setIsInfoModalOpen(false);
                }}
                onCancel={() => {
                  setIsInfoModalOpen(false);
                }}
                footer={[
                  <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                      setIsEditModalOpen(true);
                    }}
                  >
                    O'zgartirish
                  </Button>,
                  <Button
                    key="back"
                    onClick={() => {
                      setIsModalOpen(true);
                    }}
                    style={{ backgroundColor: "#f5222d", color: "#fff" }}
                  >
                    O'chirish
                  </Button>,
                ]}
              >
                <div>
                  <p className="text-[16px] m-0 p-0 ">
                    Dori: {modalData?.name}
                  </p>
                  <p className="text-[16px] m-0 p-0 ">
                    Miqdori: {modalData?.tonna}
                  </p>
                  <p className="text-[16px] m-0 p-0 ">
                    Vagon: {modalData?.vagon_number}
                  </p>
                  <p className="text-[16px] m-0 p-0 ">
                    Vagzal: {modalData?.station}
                  </p>
                  <p className="text-[16px] m-0 p-0 ">
                    TTN: {modalData?.ttn_number}
                  </p>
                  <p className="text-[16px] m-0 p-0 ">
                    Yozdi: {modalData?.written_by}
                  </p>

                  <p className="text-[16px] m-0 p-0 border-t-[2px] mt-2 border-t-[#b4b4b4] ">
                    Yuboridgan:{" "}
                    {moment(modalData?.date_uborilgan).format("DD.MM.YYYY")}
                  </p>
                  <p className="text-[16px] m-0 p-0 border-t-[2px] mt-2 border-t-[#b4b4b4] ">
                    Yetib keldi:{" "}
                    {moment(modalData?.date_qabul).format("DD.MM.YYYY")}
                  </p>
                  <p className="text-[16px] m-0 p-0 border-t-[2px] mt-2 border-t-[#b4b4b4] ">
                    Yozilgan sana:
                    {moment(modalData?.date_qabul).format("DD.MM.YYYY")}
                    <br />
                    Izoh <br />
                    {modalData?.comment}
                  </p>
                </div>
              </Modal>
              <p
                onClick={() => {
                  setIsInfoModalOpen(true);
                  setModalData({ ...el });
                }}
                className="absolute left-0 top-0"
              >
                <IoMdInformationCircleOutline />
              </p>
              <p
                className="text-[14px] text-[#111827] p-0 m-0 "
                onClick={() => {
                  copyContent(el?.name);
                }}
              >
                {el?.id}- {el?.name}
              </p>
              <h2
                className="text-[14px] text-[#6b7280] p-0 m-0"
                onClick={() => {
                  copyContent(el?.tonna);
                }}
              >
                {el?.tonna}
              </h2>
              <p
                className="text-[14px] text-[#6b7280]  p-0 m-0"
                onClick={() => {
                  copyContent(el?.station);
                }}
              >
                {el?.station}
              </p>
              <p
                className="text-[14px] text-[#6b7280]  p-0 m-0"
                onClick={() => {
                  copyContent(moment(el?.date_qabul).format("DD.MM.YYYY"));
                }}
              >
                <Tooltip
                  sx={{ fontSize: "10px" }}
                  className="text-[14px]"
                  title={`yaratildi: ${el?.date_qabul} \n updated: ${el?.updated_at}`}
                >
                  Q: {moment(el?.date_qabul).format("DD.MM.YYYY")}
                </Tooltip>
              </p>
              <p
                className="text-[14px] text-[#6b7280]  p-0 m-0"
                onClick={() => {
                  copyContent(moment(el?.date_uborilgan).format("DD.MM.YYYY"));
                }}
              >
                <Tooltip
                  sx={{ fontSize: "10px" }}
                  className="text-[14px]"
                  title={`yaratildi: ${el?.date_uborilgan} \n updated: ${el?.created_at}`}
                >
                  Y: {moment(el?.date_uborilgan).format("DD.MM.YYYY")}
                </Tooltip>
              </p>
              <p
                className="text-[14px] text-[#6b7280]  p-0 m-0"
                onClick={() => {
                  copyContent(el.ttn_number);
                }}
              >
                TTN: {el.ttn_number}
              </p>

              <p className="absolute right-0 top-0">
                <IoCheckmarkDoneCircleSharp
                  className={el.confirm ? "text-[#10b981]" : "text-[#e11d48]"}
                />
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
